import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getSettlementStoreApi } from '~/features/dashboard/api/get-settlement-store.api';
import { getRemotePcAgentUsageStatisticsApi } from '~/features/remote-pc-agent/api/get-remote-pc-agent-usage-statistics.api';

import type { SettlementStoreParams } from '~/features/dashboard/types/settlement.type';
import type { UsageStatisticsParams } from '~/features/remote-pc-agent/types/remote-pc-agent.type';
import type { StoreAnalyticsState } from '~/features/store-console/types/store-analytics.type';

const initialState: StoreAnalyticsState = {
  periodData: null,
  usageStats: null,
  isLoading: false,
};

export const fetchAnalyticsPeriodData = createAsyncThunk(
  'storeAnalytics/fetchPeriodData',
  async (params: SettlementStoreParams) => {
    const response = await getSettlementStoreApi(params);
    return response.data.data;
  },
);

export const fetchUsageStatistics = createAsyncThunk(
  'storeAnalytics/fetchUsageStatistics',
  async (params: UsageStatisticsParams) => {
    const response = await getRemotePcAgentUsageStatisticsApi(params);
    return response.data.data;
  },
);

const storeAnalyticsSlice = createSlice({
  name: 'storeAnalytics',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAnalyticsPeriodData.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchAnalyticsPeriodData.fulfilled, (state, action) => {
        state.periodData = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchAnalyticsPeriodData.rejected, state => {
        state.isLoading = false;
      })
      .addCase(fetchUsageStatistics.fulfilled, (state, action) => {
        state.usageStats = action.payload;
      });
  },
});

export default storeAnalyticsSlice;
